// Messages
// import i18n from '@nephro/core/i18n';

export const connectorError = (error) => {
  const { response = { data: {} } } = error;
  const { data = { status: 500, message: 'error' } } = response;
  return data;
};

export default connectorError;
